module.exports = __webpack_public_path__ + "img/ServicioMecanica.658c613d.png";